import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '@shared/shared.module';
import { ReactiveFormsModule } from '@angular/forms';
import { BlockLifeactComponent } from './block-lifeact.component';
import { LifeActModule } from '@app/components/lifeAct/lifeAct.module';

@NgModule({
  imports: [CommonModule, SharedModule, ReactiveFormsModule, LifeActModule],
  declarations: [BlockLifeactComponent],
  exports: [BlockLifeactComponent],
})
export class BlockLifeactModule {}
